import React, { Component } from "react";
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonMenu,
  IonItem,
  IonList,
  IonMenuButton,
  IonButtons,
  IonButton,
  IonInput,
  IonImg,
  IonSelect,
  IonSelectOption,
  IonModal,
  IonBadge,
  IonRefresher,
  IonRefresherContent,
  withIonLifeCycle,
} from "@ionic/react";
import { isPlatform, getPlatforms, RefresherEventDetail } from "@ionic/core";
import { menuController } from "@ionic/core/components";

import { RouteComponentProps, withRouter } from "react-router";

import { AppLauncher } from "@capacitor/app-launcher";
import { Browser } from "@capacitor/browser";
import { PushNotifications } from "@capacitor/push-notifications";
import { NativeSettings, AndroidSettings, IOSSettings } from "capacitor-native-settings";

// CSS
import "./DashboardPage.css";
import "../../Shared.css";
import "../../../App.css";

// Images
import iconMenu from "../../assets/Button_Menu@3x.png";
import iconClearSearch from "../../assets/Button_Cancel@3x.png";
import iconSearch from "../../assets/Button_Search_Small@3x.png";
import iconSearchDark from "../../assets/Button_Search_Small_Dark@3x.png";
import iconParaPass from "../../assets/Icon_ParaPass@3x.png";
import iconParaFolio from "../../assets/Icon_ParaFolio@3x.png";
import iconLink from "../../assets/Button_Link@3x.png";
import iconLinkDark from "../../assets/Button_Link_Dark@3x.png";
import iconBellInactive from "../../assets/Button_Bell_Inactive@3x.png";
import iconBellActive from "../../assets/Button_Bell_Active@3x.png";
import iconUpdateCN from "../../assets/Icon_Update_CN.png";
import iconUpdatePeople from "../../assets/Icon_Update_People.png";
import iconUpdatePlus from "../../assets/Icon_Update_Plus.png";
import iconUpdateHouse from "../../assets/Icon_Update_House.png";
import iconUpdatePill from "../../assets/Icon_Update_Pill.png";
import iconUpdateAck from "../../assets/Icon_Update_Ack.png";
import disclosureRight from "../../assets/Button_Disclosure_Right_Grey50@3x.png";
import iconClose from "../../assets/Button_Close_Grey@3x.png";

// Controllers
import {
  IScreenProps,
  ISignificantChange,
  IFurtherResource,
  IGuidelineSummary,
  IClinicalNotice,
  IDashboardCardState,
  ITrustPin,
  ISearchResult,
  IRecentSearch,
  IPathway,
  IEssentialSection,
} from "../../Interfaces";

import DataController from "../../controllers/DataController";
import RemoteDataController from "../../controllers/RemoteDataController";

// Components
import AppHeader from "../../components/AppHeader";
import AppCard from "../../components/AppCard";
import GuidelineCell from "../../components/GuidelineCell";
import DashboardRowCell from "../../components/DashboardRowCell";
import AgeSelector from "../../components/AgeSelector";
import SignificantChangeCell from "../../components/SignificantChangeCell";
import FurtherResourceCell from "../../components/FurtherResourceCell";

import _ from "lodash";
import ClinicalNoticeCell from "../../components/ClinicalNoticeCell";
import TrustPinCell from "../../components/TrustPinCell";
import GlobalSearchModal from "../../components/GlobalSearchModal";
import { Badge } from "@capawesome/capacitor-badge";

type Props = RouteComponentProps<{ id: string; tab: string }> & { screenProps: IScreenProps; features: string[] };
type State = {
  dashboardCardStates: IDashboardCardState[];
  pgdDropdownValue: string;
  pmaDropdownValue: string;
  smgDropdownValue: string;
  showWebBanner: boolean;
  showCustomiseDashboardCard: boolean;
  showAppNoticesCard: boolean;
  showAllTrustPins: boolean;
  showNotificationBanner: boolean;
};

class DashboardPage extends Component<Props, State> {
  private globalSearchModal: React.RefObject<GlobalSearchModal>;

  constructor(props: Props) {
    super(props);

    this.globalSearchModal = React.createRef();

    this.state = {
      dashboardCardStates: [],
      pgdDropdownValue: "All",
      pmaDropdownValue: "All",
      smgDropdownValue: "All",
      showWebBanner: false,
      showCustomiseDashboardCard: false,
      showAppNoticesCard: false,
      showAllTrustPins: false,
      showNotificationBanner: false,
    };
  }

  async componentDidMount() {
    this.props.screenProps.setAppHistory(this.props.history);

    if ((isPlatform("ios") || isPlatform("android")) && !isPlatform("mobileweb")) {
      // is native ios or android
      let notificationBannerPreviouslyDismissed = await DataController.getNotificationBannerDismissed();
      if (notificationBannerPreviouslyDismissed === false) {
        // check if notifications enabled
        PushNotifications.checkPermissions().then((res) => {
          if (res.receive !== "granted") {
            this.setState({ showNotificationBanner: true });
          }
        });
      }
    } else {
      if (this.props.screenProps.app === "Plus") {
        let customiseDashboardCardPreviouslyDismissed = await DataController.getCustomiseDashboardCardDismissed();
        if (customiseDashboardCardPreviouslyDismissed === false) {
          if (this.props.screenProps.abTestingVersion === "B") {
            this.setState({ showCustomiseDashboardCard: true });
          }
        }
      }
    }
  }

  async componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
    if (this.props.screenProps.appNotice && this.props.screenProps.appNotice !== prevProps.screenProps.appNotice) {
      let appNoticesCardPreviouslyDismissed = await DataController.getAppNoticesCardDismissed(
        this.props.screenProps.appNotice
      );
      if (appNoticesCardPreviouslyDismissed === false) {
        this.setState({ showAppNoticesCard: true });
      }
    }
  }

  async ionViewDidEnter() {
    let dashboardCardStates = await DataController.getDashboardCardStates(
      this.props.screenProps.trust,
      this.props.screenProps.testMode,
      this.props.screenProps.app
    );
    this.setState({ dashboardCardStates: dashboardCardStates });
  }

  async menuButtonClicked() {
    let menus = await menuController.toggle();
    RemoteDataController.logEvent("open_menu", {});
  }

  async editDashboard() {
    this.props.history.push("/dashboard/edit", { page: "Edit Dashboard" });
  }

  async goToNotifications() {
    this.props.history.push("/dashboard/notifications", { page: "Notifications" });
  }

  reloadData(event: CustomEvent<RefresherEventDetail>) {
    // only reload data if not already loading data
    if (this.props.screenProps.messageBarText === "") {
      this.props.screenProps.loadData();
    }
    setTimeout(() => {
      event.detail.complete();
    }, 2000);
  }

  dashbardCardCollapseButtonClicked(dashboardCardState: IDashboardCardState) {
    dashboardCardState.collapsed = !dashboardCardState.collapsed;

    this.setState({ dashboardCardStates: this.state.dashboardCardStates });
    DataController.saveDashboardCardStates(this.state.dashboardCardStates);
  }

  resetPatientAge() {
    let defaultPatientAge = DataController.getAgesObjects()[0];
    this.props.screenProps.updatePatientAge(defaultPatientAge, "Dashboard Reset");
  }

  pageForAgeButtonClicked() {
    // document.documentElement.style.setProperty('--background-primary', 'pink');

    let GLID = this.props.screenProps.patientAge.PFA;
    if (GLID != null && GLID !== "none") {
      this.props.screenProps.navigateToGuideline(
        GLID,
        this.props.match.params.tab,
        this.props.history,
        null,
        "Dashboard Page For Age"
      );
    }

    try {
      RemoteDataController.logEvent("p4a_dashboard_button_clicked", { value: this.props.screenProps.patientAge.name });
    } catch (error) {
      console.log(error);
    }
  }

  seeAllClinicalNoticesClicked() {
    this.props.history.push("/dashboard/clinicalnotices", { page: "Clinical Notices List" });
    RemoteDataController.logEvent("see_all_card_clicked", { cardName: "Clinical Notices" });
  }

  seeAllLocalClinicalUpdatesClicked() {
    this.props.history.push("/dashboard/local-clinical-updates", { page: "Local Clinical Updates List" });
    RemoteDataController.logEvent("see_all_card_clicked", { cardName: "Local Clinical Updates" });
  }

  seeAllCovid19Clicked() {
    this.props.history.push("/dashboard/covid19", { page: "Covid 19 List" });
    RemoteDataController.logEvent("see_all_card_clicked", { cardName: "COVID-19" });
  }

  seeAllTimeCriticalClicked() {
    this.props.history.push("/dashboard/timecritical", { page: "Time Critical List" });
    RemoteDataController.logEvent("see_all_card_clicked", { cardName: "Time Critical" });
  }

  seeAllSharedProceduresClicked() {
    this.props.history.push("/dashboard/sharedprocedures", { page: "Shared Procedures List" });
    RemoteDataController.logEvent("see_all_card_clicked", { cardName: "Shared Procedures" });
  }

  seeAllPageForAgeClicked() {
    this.props.history.push("/pageforage", { page: "Page For Age List" });
    RemoteDataController.logEvent("see_all_card_clicked", { cardName: "Page for Age" });
  }

  seeAllAcknowledgeableGuidelinesClicked() {
    this.props.history.push("/dashboard/guideline-acks", { page: "Trust Acknowledgeable Guidelines List" });
    RemoteDataController.logEvent("see_all_card_clicked", { cardName: "Trust Acknowledgeable Guidelines" });
  }

  seeAllSignificantChangesClicked() {
    this.props.history.push("/dashboard/updates", { page: "Guideline Updates List" });
    RemoteDataController.logEvent("see_all_card_clicked", { cardName: "Guideline Updates" });
  }

  seeAllPGDsClicked() {
    this.props.history.push("/dashboard/pgds", { page: "PGD List" });
    RemoteDataController.logEvent("see_all_card_clicked", { cardName: "PGDs" });
  }

  seeAllPMAsClicked() {
    this.props.history.push("/dashboard/pmas", { page: "PMA List" });
    RemoteDataController.logEvent("see_all_card_clicked", { cardName: "PMAs" });
  }

  seeAllSMGsClicked() {
    let trust = "";
    if (this.props.screenProps.user) {
      trust = this.props.screenProps.user?.trust;
    }
    if (trust === "LAS") {
      this.props.history.push("/dashboard/supplementary-medication-guidelines", { page: "SMG List" });
    } else if (trust === "EMAS") {
      this.props.history.push("/dashboard/medication-supply-guidelines", { page: "SMG List" });
    }

    RemoteDataController.logEvent("see_all_card_clicked", { cardName: "SMGs" });
  }

  seeAllBookmarksClicked() {
    this.props.history.push("/dashboard/bookmarks", { page: "Bookmarks List" });
    RemoteDataController.logEvent("see_all_card_clicked", { cardName: "Bookmarks" });
  }

  seeAllRecentlyViewedClicked() {
    this.props.history.push("/dashboard/recentlyviewed", { page: "Recently Viewed List" });
    RemoteDataController.logEvent("see_all_card_clicked", { cardName: "Recently Viewed" });
  }

  seeAllTrustGuidelinesClicked() {
    this.props.history.push("/dashboard/trustmedsguidelines", { page: "Trust Guidelines List" });
    RemoteDataController.logEvent("see_all_card_clicked", { cardName: "Trust Guidelines" });
  }

  navigateToGuideline(GLID: string, from: string) {
    // from used for analytics
    this.props.screenProps.navigateToGuideline(GLID, this.props.match.params.tab, this.props.history, null, from);
  }

  bookmarkedGuidelineClicked(GLID: string) {
    this.navigateToGuideline(GLID, "Dashboard Bookmark");
  }

  pageForAgeCellClicked(GLID: string) {
    this.navigateToGuideline(GLID, "Dashboard Page For Age Cell");
  }

  recentlyViewedGuidelineClicked(GLID: string) {
    this.navigateToGuideline(GLID, "Dashboard Recently Viewed");
  }

  covidCellClicked(GLID: string) {
    this.navigateToGuideline(GLID, "Dashboard Covid");
  }

  timeCriticalCellClicked(GLID: string) {
    this.navigateToGuideline(GLID, "Dashboard Time Critical");
  }

  sharedProcedureCellClicked(GLID: string) {
    this.navigateToGuideline(GLID, "Dashboard Shared Procedure");
  }

  pgdCellClicked(GLID: string) {
    this.navigateToGuideline(GLID, "Dashboard PGD");
  }

  pmaCellClicked(GLID: string) {
    this.navigateToGuideline(GLID, "Dashboard PMA");
  }

  smgCellClicked(GLID: string) {
    this.navigateToGuideline(GLID, "Dashboard SMG");
  }

  navigateToAlgorithm(id: string, from: string) {
    this.props.screenProps.navigateToAlgorithm(id, this.props.match.params.tab, this.props.history, from);
  }

  bookmarkedAlgorithmClicked(id: string) {
    this.navigateToAlgorithm(id, "Dashboard Bookmark");
  }

  recentlyViewedAlgorithmClicked(GLID: string) {
    this.navigateToAlgorithm(GLID, "Dashboard Recently Viewed");
  }

  navigateToClinicalNotice(clinicalNotice: IClinicalNotice, from: string) {
    this.props.screenProps.navigateToClinicalNotice(
      clinicalNotice.ID,
      this.props.match.params.tab,
      this.props.history,
      null,
      from
    );
  }

  bookmarkedClinicalNoticeClicked(clinicalNotice: IClinicalNotice) {
    this.navigateToClinicalNotice(clinicalNotice, "Dashboard Bookmark");
  }

  recentlyViewedClinicalNoticeClicked(clinicalNotice: IClinicalNotice) {
    this.navigateToClinicalNotice(clinicalNotice, "Dashboard Recently Viewed");
  }

  covidClinicalNoticeClicked(clinicalNotice: IClinicalNotice) {
    this.navigateToClinicalNotice(clinicalNotice, "Dashboard Covid");
  }

  clinicalNoticeClicked(clinicalNotice: IClinicalNotice) {
    this.navigateToClinicalNotice(clinicalNotice, "Dashboard Clinical Notice");
  }

  navigateToPathway(pathway: IPathway, from: string) {
    this.props.screenProps.navigateToPathway(pathway, this.props.match.params.tab, this.props.history, from);
  }

  bookmarkedPathwayClicked(pathway: IPathway) {
    this.navigateToPathway(pathway, "Dashboard Bookmark");
  }

  bookmarkedEssentialSectionsClicked(essentialSection: IEssentialSection) {
    this.props.screenProps.navigateToEssentialSection(
      essentialSection,
      this.props.match.params.tab,
      this.props.history,
      "Dashboard Bookmark"
    );
  }

  recentlyViewedPathwayClicked(pathway: IPathway) {
    this.navigateToPathway(pathway, "Dashboard Recently Viewed");
  }

  async furtherResourceCellClicked(furtherResource: IFurtherResource) {
    console.log("opening further resource");

    let type = furtherResource.type;

    if (type === "guideline") {
      if (furtherResource.GLID != null && furtherResource.GLID !== "") {
        this.navigateToGuideline(furtherResource.GLID, "Dashboard Further Resource");
      }
    }

    if (type === "web link") {
      if (furtherResource.link != null && furtherResource.link !== "") {
        Browser.open({ url: furtherResource.link });
      }
    }

    if (type === "app link") {
      if (isPlatform("ios")) {
        if (furtherResource.iosDeepLink != null && furtherResource.iosDeepLink !== "") {
          var canOpenApp = await AppLauncher.canOpenUrl({ url: furtherResource.iosDeepLink });

          if (canOpenApp) {
            var appOpenedState = await AppLauncher.openUrl({ url: furtherResource.iosDeepLink });

            if (!appOpenedState.completed) {
              if (furtherResource.iosAppLink != null && furtherResource.iosAppLink !== "") {
                Browser.open({ url: furtherResource.iosAppLink });
              } else {
                if (furtherResource.link != null && furtherResource.link !== "") {
                  Browser.open({ url: furtherResource.link });
                }
              }
            }
          } else {
            if (furtherResource.iosAppLink != null && furtherResource.iosAppLink !== "") {
              Browser.open({ url: furtherResource.iosAppLink });
            } else {
              if (furtherResource.link != null && furtherResource.link !== "") {
                Browser.open({ url: furtherResource.link });
              }
            }
          }
        } else if (furtherResource.iosAppLink != null && furtherResource.iosAppLink !== "") {
          Browser.open({ url: furtherResource.iosAppLink });
        } else {
          if (furtherResource.link != null && furtherResource.link !== "") {
            Browser.open({ url: furtherResource.link });
          }
        }
      } else if (isPlatform("android")) {
        if (furtherResource.androidPackage != null && furtherResource.androidPackage !== "") {
          let canOpenApp = await AppLauncher.canOpenUrl({ url: furtherResource.androidPackage });

          if (canOpenApp) {
            let appOpenedState = await AppLauncher.openUrl({ url: furtherResource.androidPackage });

            if (!appOpenedState.completed) {
              if (furtherResource.googlePlayLink != null && furtherResource.googlePlayLink !== "") {
                Browser.open({ url: furtherResource.googlePlayLink });
              } else {
                if (furtherResource.link != null && furtherResource.link !== "") {
                  Browser.open({ url: furtherResource.link });
                }
              }
            }
          } else {
            if (furtherResource.googlePlayLink != null && furtherResource.googlePlayLink !== "") {
              Browser.open({ url: furtherResource.googlePlayLink });
            } else {
              if (furtherResource.link != null && furtherResource.link !== "") {
                Browser.open({ url: furtherResource.link });
              }
            }
          }
        } else {
          if (furtherResource.googlePlayLink != null && furtherResource.googlePlayLink !== "") {
            Browser.open({ url: furtherResource.googlePlayLink });
          } else {
            if (furtherResource.link != null && furtherResource.link !== "") {
              Browser.open({ url: furtherResource.link });
            }
          }
        }
      } else {
        if (furtherResource.link != null && furtherResource.link !== "") {
          Browser.open({ url: furtherResource.link });
        }
      }
    }

    if (type === "pdf") {
      if (furtherResource.link != null && furtherResource.link !== "") {
        Browser.open({ url: furtherResource.link });
      }
    }

    RemoteDataController.logEvent("further_resource_clicked", {
      furtherResourceName: furtherResource.name,
    });
  }

  trustPinCellClicked(trustPin: ITrustPin) {
    let guidelines = trustPin.guidelines;
    if (trustPin.guidelinesInSections && trustPin.guidelinesInSections.length > 0) {
      guidelines = guidelines.concat(trustPin.guidelinesInSections);
    }

    if (trustPin.type === "Custom List") {
      if (guidelines.length === 1 && trustPin.algorithms.length === 0 && trustPin.clinicalNotices.length === 0) {
        // single guideline
        let GLID = guidelines[0];
        this.navigateToGuideline(GLID, "Dashboad Trust Pin");
      } else if (guidelines.length === 0 && trustPin.algorithms.length === 1 && trustPin.clinicalNotices.length === 0) {
        // single algorithm
        let algorithmID = trustPin.algorithms[0];
        this.navigateToAlgorithm(algorithmID, "Dashboard Trust Pin");
      } else if (guidelines.length === 0 && trustPin.algorithms.length === 0 && trustPin.clinicalNotices.length === 1) {
        // single clinical notice
        try {
          let clinicalNoticeID = parseInt(trustPin.clinicalNotices[0]);

          // find clinical notice
          let clinicalNotice = this.props.screenProps.clinicalNotices.find(
            (clinicalNotice) => clinicalNotice.ID === clinicalNoticeID
          );

          if (clinicalNotice) {
            this.navigateToClinicalNotice(clinicalNotice, "Dashboard Trust Pin");
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        // multiple items
        this.props.screenProps.navigateToTrustPinsList(trustPin, this.props.match.params.tab, this.props.history);
      }
    } else if (trustPin.type === "Further Resource") {
      if (trustPin.furtherResourceID.length === 1) {
        let furtherResourceID = trustPin.furtherResourceID[0];
        let furtherResource = this.props.screenProps.furtherResources.find(
          (furtherResource) => furtherResource.resourceID === furtherResourceID
        );
        if (furtherResource) {
          this.furtherResourceCellClicked(furtherResource);
        }
      }
    } else if (trustPin.type === "All PGDs") {
      this.seeAllPGDsClicked();
    } else if (trustPin.type === "All Trust Guidelines") {
      this.props.history.push(`/dashboard/trustguidelines/`, { page: "Trust Guidelines List" });
    }

    if (this.props.screenProps.user) {
      RemoteDataController.logEvent("trust_pin_clicked", {
        trustPinName: trustPin.name,
        trust: this.props.screenProps.trust,
      });
    }
  }

  significantChangeCellClicked(significantChange: ISignificantChange) {
    this.navigateToGuideline(significantChange.GLID, "Dashboard Significant Change");
  }

  significantChangeCellAcknowledgeButtonClicked(significantChange: ISignificantChange) {
    this.props.screenProps.acknowledgeSignificantChange(significantChange, "Dashboard");
  }

  goToAppSettings() {
    try {
      if ((isPlatform("ios") || isPlatform("android")) && !isPlatform("mobileweb")) {
        NativeSettings.open({
          optionAndroid: AndroidSettings.ApplicationDetails,
          optionIOS: IOSSettings.App,
        });
      }
    } catch (error) {
      console.log(error);
    }
  }

  dismissNotificationBanner() {
    this.setState({ showNotificationBanner: false });
    DataController.saveNotificationBannerDismissed();
  }

  dismissWebBanner() {
    this.setState({ showWebBanner: false });
    DataController.saveWebBannerDismissed();
  }

  dismissCustomiseDashboardCard() {
    this.setState({ showCustomiseDashboardCard: false });
    DataController.saveCustomiseDashboardCardDismissed();
  }

  dismissAppNoticesCard() {
    this.setState({ showAppNoticesCard: false });
    if (this.props.screenProps.appNotice != null) {
      DataController.saveAppNoticesCardDismissed(this.props.screenProps.appNotice);
    }
  }

  appNoticeCardActionButtonClicked() {
    const appNotice = this.props.screenProps.appNotice;
    if (appNotice != null && appNotice.link) {
      if (DataController.isLocalLink(appNotice.link)) {
        let localLink = DataController.stripLocalLinks(appNotice.link);
        this.props.history.push(localLink, { page: "App Notice Card Action" });
      } else {
        Browser.open({ url: appNotice.link });
      }
    }
  }

  updateTotalUpdatesCount(totalUpdatesCount: number) {
    if ((isPlatform("ios") || isPlatform("android")) && isPlatform("mobileweb") === false) {
      Badge.set({ count: totalUpdatesCount });
    }
  }

  render() {
    let trust = "";
    if (this.props.screenProps.user) {
      trust = this.props.screenProps.user?.trust;
    }

    let guidelineSummaryAckGLIDs = this.props.screenProps.glAcks.map((glAck) => glAck.GLID);

    let bookmarkCardCells = [];

    let recentlyViewedCardCells = [];

    let pageForAgeCardGuidelineSummaries: IGuidelineSummary[] = [];
    let pageForAgeCardCells = [];

    let covidCardGuidelineSummaries: IGuidelineSummary[] = [];
    let covidCardClinicalNotices: IClinicalNotice[] = [];
    let covidCardCells = [];

    let timeCriticalCardGuidelineSummaries: IGuidelineSummary[] = [];
    let timeCriticalCardCells = [];

    let sharedProcedureCardGuidelineSummaries: IGuidelineSummary[] = [];
    let sharedProcedureCardCells = [];

    let clinicalNoticeCardClinicalNotices: IClinicalNotice[] = [];
    let clinicalNoticeCardCells = [];

    let localClinicalUpdatesCardClinicalNotices: IClinicalNotice[] = [];
    let localClinicalUpdatesCardCells = [];

    let furtherResourceCells = [];

    let guidelineBookmarkGLIDs = this.props.screenProps.bookmarks
      .filter((bookmark) => bookmark.type === "guideline")
      .map((bookmark) => bookmark.GLID);
    let algorithmBookmarkIDs = this.props.screenProps.bookmarks
      .filter((bookmark) => bookmark.type === "algorithm")
      .map((bookmark) => bookmark.algorithmID);
    let clinicalNoticeBookmarkIDs = this.props.screenProps.bookmarks
      .filter((bookmark) => bookmark.type === "clinical notice")
      .map((bookmark) => bookmark.clinicalNoticeID);
    let pathwayBookmarkIDs = this.props.screenProps.bookmarks
      .filter((bookmark) => bookmark.type === "pathway")
      .map((bookmark) => bookmark.pathwayID);

    let significantChangeCells = [];

    let pgdCardGuidelineSummaries: IGuidelineSummary[] = [];
    let pgdCardCells = [];
    let pgdUnauthorisedCount = 0;

    let pmaCardGuidelineSummaries: IGuidelineSummary[] = [];
    let pmaCardCells = [];
    let pmaUnauthorisedCount = 0;

    let smgCardGuidelineSummaries: IGuidelineSummary[] = [];
    let smgCardCells = [];
    let smgUnauthorisedCount = 0;

    let trustPinCells = [];
    let trustPinsDisplayedAsCards = [];

    let trustGuidelineSummaries: IGuidelineSummary[] = [];
    let trustGuidelineCardCells = [];

    let acknowledgedGuidelineSummaries: IGuidelineSummary[] = [];
    let unacknowledgedGuidelineSummariesCount = 0;

    const maxCells = 2;

    // get guideline for each card
    for (
      let guidelineSummaryIndex = 0;
      guidelineSummaryIndex < this.props.screenProps.guidelineSummaries.length;
      guidelineSummaryIndex++
    ) {
      let guidelineSummary = this.props.screenProps.guidelineSummaries[guidelineSummaryIndex];

      if (DataController.isPageForAge(guidelineSummary.GLID)) {
        pageForAgeCardGuidelineSummaries.push(guidelineSummary);
      }

      if (guidelineSummary.Section.includes("Covid-19")) {
        covidCardGuidelineSummaries.push(guidelineSummary);
      }

      if (guidelineSummary.Section.includes("TimeCritical")) {
        timeCriticalCardGuidelineSummaries.push(guidelineSummary);
      }

      if (DataController.isSharedProcedure(guidelineSummary)) {
        sharedProcedureCardGuidelineSummaries.push(guidelineSummary);
      }

      if (DataController.isPGD(guidelineSummary)) {
        pgdCardGuidelineSummaries.push(guidelineSummary);
      }

      if (DataController.isPMA(guidelineSummary)) {
        pmaCardGuidelineSummaries.push(guidelineSummary);
      }

      if (DataController.isSMG(guidelineSummary)) {
        smgCardGuidelineSummaries.push(guidelineSummary);
      }

      if (guidelineSummary.trust != null && guidelineSummary.trust !== "") {
        trustGuidelineSummaries.push(guidelineSummary);
      }

      if (guidelineSummary.SupportAcknowledment) {
        acknowledgedGuidelineSummaries.push(guidelineSummary);
        if (guidelineSummaryAckGLIDs.includes(guidelineSummary.GLID) === false) {
          unacknowledgedGuidelineSummariesCount++;
        }
      }
    }

    trustGuidelineSummaries = _.orderBy(
      trustGuidelineSummaries,
      [(guidelineSummary) => guidelineSummary.Title.toLowerCase()],
      ["asc"]
    );

    pageForAgeCardGuidelineSummaries = _.sortBy(pageForAgeCardGuidelineSummaries, ["GLID"]);

    // get clinical notices for each card
    for (
      let clinicalNoticeIndex = 0;
      clinicalNoticeIndex < this.props.screenProps.clinicalNotices.length;
      clinicalNoticeIndex++
    ) {
      let clinicalNotice = this.props.screenProps.clinicalNotices[clinicalNoticeIndex];

      if (this.props.features.includes("localClinicalUpdates") && clinicalNotice.localClinicalUpdate) {
        localClinicalUpdatesCardClinicalNotices.push(clinicalNotice);
      } else {
        clinicalNoticeCardClinicalNotices.push(clinicalNotice);
      }

      if (
        clinicalNotice.Title.toLowerCase().includes("covid") ||
        clinicalNotice.Title.toLowerCase().includes("coronavirus")
      ) {
        covidCardClinicalNotices.push(clinicalNotice);
      }
    }

    // render bookmark card cells
    for (let bookmarkIndex = 0; bookmarkIndex < this.props.screenProps.bookmarks.length; bookmarkIndex++) {
      let bookmark = this.props.screenProps.bookmarks[bookmarkIndex];

      if (bookmark.type === "guideline") {
        for (
          let guidelineSummaryIndex = 0;
          guidelineSummaryIndex < this.props.screenProps.guidelineSummaries.length;
          guidelineSummaryIndex++
        ) {
          let guidelineSummary = this.props.screenProps.guidelineSummaries[guidelineSummaryIndex];

          if (guidelineSummary.GLID === bookmark.GLID) {
            if (bookmarkCardCells.length < maxCells) {
              bookmarkCardCells.push(
                <div className="dashboardRowCell" key={guidelineSummary.GLID}>
                  <DashboardRowCell
                    guidelineSummary={guidelineSummary}
                    bookmarked={guidelineBookmarkGLIDs.includes(guidelineSummary.GLID)}
                    cellClicked={() => this.bookmarkedGuidelineClicked(guidelineSummary.GLID)}
                    darkMode={this.props.screenProps.darkMode}
                  />
                </div>
              );
            }
          }
        }
      } else if (bookmark.type === "algorithm") {
        for (let algorithmIndex = 0; algorithmIndex < this.props.screenProps.algorithms.length; algorithmIndex++) {
          let algorithm = this.props.screenProps.algorithms[algorithmIndex];

          if (algorithm.id === bookmark.algorithmID) {
            if (bookmarkCardCells.length < maxCells) {
              bookmarkCardCells.push(
                <div className="dashboardRowCell" key={algorithm.id}>
                  <DashboardRowCell
                    algorithm={algorithm}
                    bookmarked={algorithmBookmarkIDs.includes(algorithm.id)}
                    cellClicked={() => this.bookmarkedAlgorithmClicked(algorithm.id)}
                    darkMode={this.props.screenProps.darkMode}
                  />
                </div>
              );
            }
          }
        }
      } else if (bookmark.type === "clinical notice") {
        for (
          let clinicalNoticeIndex = 0;
          clinicalNoticeIndex < this.props.screenProps.clinicalNotices.length;
          clinicalNoticeIndex++
        ) {
          let clinicalNotice = this.props.screenProps.clinicalNotices[clinicalNoticeIndex];

          if (clinicalNotice.ID === bookmark.clinicalNoticeID) {
            if (bookmarkCardCells.length < maxCells) {
              bookmarkCardCells.push(
                <div className="dashboardRowCell" key={clinicalNotice.ID}>
                  <DashboardRowCell
                    clinicalNotice={clinicalNotice}
                    bookmarked={clinicalNoticeBookmarkIDs.includes(clinicalNotice.ID)}
                    cellClicked={() => this.bookmarkedClinicalNoticeClicked(clinicalNotice)}
                    darkMode={this.props.screenProps.darkMode}
                  />
                </div>
              );
            }
          }
        }
      } else if (bookmark.type === "pathway") {
        if (this.props.screenProps.pathwayData) {
          for (
            let pathwayIndex = 0;
            pathwayIndex < this.props.screenProps.pathwayData.Pathways.length;
            pathwayIndex++
          ) {
            let pathway = this.props.screenProps.pathwayData.Pathways[pathwayIndex];

            if (pathway.id === bookmark.pathwayID) {
              if (bookmarkCardCells.length < maxCells) {
                bookmarkCardCells.push(
                  <div className="dashboardRowCell" key={pathway.id}>
                    <DashboardRowCell
                      pathway={pathway}
                      bookmarked={pathwayBookmarkIDs.includes(pathway.id)}
                      cellClicked={() => this.bookmarkedPathwayClicked(pathway)}
                      darkMode={this.props.screenProps.darkMode}
                    />
                  </div>
                );
              }
            }
          }
        }
      } else if (bookmark.type === "essentials") {
        for (
          let essentialSectionIndex = 0;
          essentialSectionIndex < this.props.screenProps.essentialSections.length;
          essentialSectionIndex++
        ) {
          let essentialSection = this.props.screenProps.essentialSections[essentialSectionIndex];

          if (essentialSection.id === bookmark.GLID) {
            if (bookmarkCardCells.length < maxCells) {
              bookmarkCardCells.push(
                <div className="dashboardRowCell" key={essentialSection.id}>
                  <DashboardRowCell
                    essentialSection={essentialSection}
                    bookmarked={true}
                    cellClicked={() => this.bookmarkedEssentialSectionsClicked(essentialSection)}
                    darkMode={this.props.screenProps.darkMode}
                  />
                </div>
              );
            }
          }
        }
      }
    }

    // render recently viewed card cells
    for (
      let recentlyViewedIndex = 0;
      recentlyViewedIndex < this.props.screenProps.recentlyViewed.length;
      recentlyViewedIndex++
    ) {
      let recentlyViewed = this.props.screenProps.recentlyViewed[recentlyViewedIndex];

      if (recentlyViewed.type === "guideline") {
        for (
          let guidelineSummaryIndex = 0;
          guidelineSummaryIndex < this.props.screenProps.guidelineSummaries.length;
          guidelineSummaryIndex++
        ) {
          let guidelineSummary = this.props.screenProps.guidelineSummaries[guidelineSummaryIndex];

          if (guidelineSummary.GLID === recentlyViewed.GLID) {
            if (recentlyViewedCardCells.length < maxCells) {
              recentlyViewedCardCells.push(
                <div className="dashboardRowCell" key={guidelineSummary.GLID}>
                  <DashboardRowCell
                    guidelineSummary={guidelineSummary}
                    bookmarked={guidelineBookmarkGLIDs.includes(guidelineSummary.GLID)}
                    cellClicked={() => this.recentlyViewedGuidelineClicked(guidelineSummary.GLID)}
                    darkMode={this.props.screenProps.darkMode}
                  />
                </div>
              );
            }
          }
        }
      } else if (recentlyViewed.type === "algorithm") {
        for (let algorithmIndex = 0; algorithmIndex < this.props.screenProps.algorithms.length; algorithmIndex++) {
          let algorithm = this.props.screenProps.algorithms[algorithmIndex];

          if (algorithm.id === recentlyViewed.algorithmID) {
            if (recentlyViewedCardCells.length < maxCells) {
              recentlyViewedCardCells.push(
                <div className="dashboardRowCell" key={algorithm.id}>
                  <DashboardRowCell
                    algorithm={algorithm}
                    bookmarked={algorithmBookmarkIDs.includes(algorithm.id)}
                    cellClicked={() => this.recentlyViewedAlgorithmClicked(algorithm.id)}
                    darkMode={this.props.screenProps.darkMode}
                  />
                </div>
              );
            }
          }
        }
      } else if (recentlyViewed.type === "clinical notice") {
        for (
          let clinicalNoticeIndex = 0;
          clinicalNoticeIndex < this.props.screenProps.clinicalNotices.length;
          clinicalNoticeIndex++
        ) {
          let clinicalNotice = this.props.screenProps.clinicalNotices[clinicalNoticeIndex];

          if (clinicalNotice.ID === recentlyViewed.clinicalNoticeID) {
            if (recentlyViewedCardCells.length < maxCells) {
              recentlyViewedCardCells.push(
                <div className="dashboardRowCell" key={clinicalNotice.ID}>
                  <DashboardRowCell
                    clinicalNotice={clinicalNotice}
                    bookmarked={clinicalNoticeBookmarkIDs.includes(clinicalNotice.ID)}
                    cellClicked={() => this.recentlyViewedClinicalNoticeClicked(clinicalNotice)}
                    darkMode={this.props.screenProps.darkMode}
                  />
                </div>
              );
            }
          }
        }
      } else if (recentlyViewed.type === "pathway") {
        if (this.props.screenProps.pathwayData) {
          for (
            let pathwayIndex = 0;
            pathwayIndex < this.props.screenProps.pathwayData.Pathways.length;
            pathwayIndex++
          ) {
            let pathway = this.props.screenProps.pathwayData.Pathways[pathwayIndex];

            if (pathway.id === recentlyViewed.pathwayID) {
              if (recentlyViewedCardCells.length < maxCells) {
                recentlyViewedCardCells.push(
                  <div className="dashboardRowCell" key={pathway.id}>
                    <DashboardRowCell
                      pathway={pathway}
                      bookmarked={pathwayBookmarkIDs.includes(pathway.id)}
                      cellClicked={() => this.recentlyViewedPathwayClicked(pathway)}
                      darkMode={this.props.screenProps.darkMode}
                    />
                  </div>
                );
              }
            }
          }
        }
      }
    }

    // render guideline cells for page for age card
    for (
      let pageForAgeCardIndex = 0;
      pageForAgeCardIndex < pageForAgeCardGuidelineSummaries.length;
      pageForAgeCardIndex++
    ) {
      let guidelineSummary = pageForAgeCardGuidelineSummaries[pageForAgeCardIndex];

      let updated = this.props.screenProps.isGuidelineUpdated(guidelineSummary);

      pageForAgeCardCells.push(
        <div className="dashboardGuidelineCell" key={guidelineSummary.GLID}>
          <GuidelineCell
            guidelineSummary={guidelineSummary}
            userTrust={trust}
            bookmarked={false}
            updated={updated}
            cellClicked={this.pageForAgeCellClicked.bind(this)}
            screenProps={this.props.screenProps}
          />
        </div>
      );
    }

    // render guideline cells for covid card
    for (let covidCardIndex = 0; covidCardIndex < covidCardGuidelineSummaries.length; covidCardIndex++) {
      let guidelineSummary = covidCardGuidelineSummaries[covidCardIndex];

      let updated = this.props.screenProps.isGuidelineUpdated(guidelineSummary);

      let pgdAck = null;
      if (DataController.isAuthorisableGuideline(guidelineSummary)) {
        pgdAck = this.props.screenProps.pgdAcks.find((aPgdAck) => aPgdAck.GLID === guidelineSummary.GLID);
      }

      let glAck = null;
      if (guidelineSummary.SupportAcknowledment === true) {
        glAck = this.props.screenProps.glAcks.find((aGLAck) => aGLAck.GLID === guidelineSummary.GLID);
      }

      covidCardCells.push(
        <div className="dashboardGuidelineCell" key={guidelineSummary.GLID}>
          <GuidelineCell
            guidelineSummary={guidelineSummary}
            userTrust={trust}
            pgdAck={pgdAck}
            glAck={glAck}
            bookmarked={guidelineBookmarkGLIDs.includes(guidelineSummary.GLID)}
            updated={updated}
            cellClicked={this.covidCellClicked.bind(this)}
            screenProps={this.props.screenProps}
          />
        </div>
      );
    }

    // render clinical notice cells for covid card
    for (let covidCardIndex = 0; covidCardIndex < covidCardClinicalNotices.length; covidCardIndex++) {
      let clinicalNotice = covidCardClinicalNotices[covidCardIndex];

      let isCNAcknowledged = DataController.isCNAcknowledged(clinicalNotice, this.props.screenProps.clinicalNoticeAcks);

      covidCardCells.push(
        <div className="dashboardGuidelineCell" key={clinicalNotice.ID}>
          <ClinicalNoticeCell
            clinicalNotice={clinicalNotice}
            acknowledged={isCNAcknowledged}
            bookmarked={clinicalNoticeBookmarkIDs.includes(clinicalNotice.ID)}
            cellClicked={this.covidClinicalNoticeClicked.bind(this)}
          />
        </div>
      );
    }

    // render guideline cells for time critical card
    for (
      let timeCriticalCardIndex = 0;
      timeCriticalCardIndex < timeCriticalCardGuidelineSummaries.length;
      timeCriticalCardIndex++
    ) {
      let guidelineSummary = timeCriticalCardGuidelineSummaries[timeCriticalCardIndex];

      let updated = this.props.screenProps.isGuidelineUpdated(guidelineSummary);

      let pgdAck = null;
      if (DataController.isAuthorisableGuideline(guidelineSummary)) {
        pgdAck = this.props.screenProps.pgdAcks.find((aPgdAck) => aPgdAck.GLID === guidelineSummary.GLID);
      }

      let glAck = null;
      if (guidelineSummary.SupportAcknowledment === true) {
        glAck = this.props.screenProps.glAcks.find((aGLAck) => aGLAck.GLID === guidelineSummary.GLID);
      }

      timeCriticalCardCells.push(
        <div className="dashboardGuidelineCell" key={guidelineSummary.GLID}>
          <GuidelineCell
            guidelineSummary={guidelineSummary}
            userTrust={trust}
            pgdAck={pgdAck}
            glAck={glAck}
            bookmarked={guidelineBookmarkGLIDs.includes(guidelineSummary.GLID)}
            updated={updated}
            cellClicked={this.timeCriticalCellClicked.bind(this)}
            screenProps={this.props.screenProps}
          />
        </div>
      );
    }

    // render guideline cells for shared procedures card
    for (
      let sharedProceduresCardIndex = 0;
      sharedProceduresCardIndex < sharedProcedureCardGuidelineSummaries.length;
      sharedProceduresCardIndex++
    ) {
      let guidelineSummary = sharedProcedureCardGuidelineSummaries[sharedProceduresCardIndex];

      let updated = this.props.screenProps.isGuidelineUpdated(guidelineSummary);

      let pgdAck = null;
      // if (DataController.isAuthorisableGuideline(guidelineSummary)) {
      //   pgdAck = this.props.screenProps.pgdAcks.find(aPgdAck => aPgdAck.GLID === guidelineSummary.GLID);
      // }

      let glAck = null;
      if (guidelineSummary.SupportAcknowledment === true) {
        glAck = this.props.screenProps.glAcks.find((aGLAck) => aGLAck.GLID === guidelineSummary.GLID);
      }

      sharedProcedureCardCells.push(
        <div className="dashboardGuidelineCell" key={guidelineSummary.GLID}>
          <GuidelineCell
            guidelineSummary={guidelineSummary}
            userTrust={trust}
            pgdAck={pgdAck}
            glAck={glAck}
            bookmarked={guidelineBookmarkGLIDs.includes(guidelineSummary.GLID)}
            updated={updated}
            cellClicked={this.sharedProcedureCellClicked.bind(this)}
            screenProps={this.props.screenProps}
          />
        </div>
      );
    }

    // render guideline cells for pgd card
    let firstUnauthorisedPGD = null;
    for (let pgdCardIndex = 0; pgdCardIndex < pgdCardGuidelineSummaries.length; pgdCardIndex++) {
      let guidelineSummary = pgdCardGuidelineSummaries[pgdCardIndex];

      let updated = this.props.screenProps.isGuidelineUpdated(guidelineSummary);

      let pgdAck = null;
      if (DataController.isAuthorisableGuideline(guidelineSummary)) {
        pgdAck = this.props.screenProps.pgdAcks.find((aPgdAck) => aPgdAck.GLID === guidelineSummary.GLID);
      }

      let glAck = null;
      if (guidelineSummary.SupportAcknowledment === true) {
        glAck = this.props.screenProps.glAcks.find((aGLAck) => aGLAck.GLID === guidelineSummary.GLID);
      }

      let pgdStatus = DataController.getPGDStatus(guidelineSummary, pgdAck, this.props.screenProps.pgdTrustInfo);

      let pgdUnauthorised =
        pgdStatus === "UnauthorisedAcknowledge" ||
        pgdStatus === "UnauthorisedQuizTaken" ||
        pgdStatus === "UnauthorisedTakeQuiz";

      if (pgdUnauthorised) {
        pgdUnauthorisedCount++;
        if (firstUnauthorisedPGD == null) {
          firstUnauthorisedPGD = guidelineSummary;
        }
      }

      // filter out pgds which don't match dropdown
      if (this.state.pgdDropdownValue === "Authorised" && pgdStatus !== "Authorised") {
        continue;
      } else if (this.state.pgdDropdownValue === "Unauthorised" && !pgdUnauthorised) {
        continue;
      }

      pgdCardCells.push(
        <div className="dashboardGuidelineCell" key={guidelineSummary.GLID}>
          <GuidelineCell
            guidelineSummary={guidelineSummary}
            userTrust={trust}
            pgdAck={pgdAck}
            glAck={glAck}
            bookmarked={guidelineBookmarkGLIDs.includes(guidelineSummary.GLID)}
            updated={updated}
            cellClicked={this.pgdCellClicked.bind(this)}
            screenProps={this.props.screenProps}
          />
        </div>
      );
    }

    // render guideline cells for pma card
    let firstUnauthorisedPMA = null;
    for (let pmaCardIndex = 0; pmaCardIndex < pmaCardGuidelineSummaries.length; pmaCardIndex++) {
      let guidelineSummary = pmaCardGuidelineSummaries[pmaCardIndex];

      let updated = this.props.screenProps.isGuidelineUpdated(guidelineSummary);

      let pgdAck = null;
      if (DataController.isAuthorisableGuideline(guidelineSummary)) {
        pgdAck = this.props.screenProps.pgdAcks.find((aPgdAck) => aPgdAck.GLID === guidelineSummary.GLID);
      }

      let glAck = null;
      if (guidelineSummary.SupportAcknowledment === true) {
        glAck = this.props.screenProps.glAcks.find((aGLAck) => aGLAck.GLID === guidelineSummary.GLID);
      }

      let pgdStatus = DataController.getPGDStatus(guidelineSummary, pgdAck, this.props.screenProps.pgdTrustInfo);

      let pmaUnauthorised =
        pgdStatus === "UnauthorisedAcknowledge" ||
        pgdStatus === "UnauthorisedQuizTaken" ||
        pgdStatus === "UnauthorisedTakeQuiz";

      if (pmaUnauthorised) {
        pmaUnauthorisedCount++;
        if (firstUnauthorisedPMA == null) {
          firstUnauthorisedPMA = guidelineSummary;
        }
      }

      // filter out pma's which don't match dropdown
      if (this.state.pmaDropdownValue === "Authorised" && pgdStatus !== "Authorised") {
        continue;
      } else if (this.state.pmaDropdownValue === "Unauthorised" && !pmaUnauthorised) {
        continue;
      }

      pmaCardCells.push(
        <div className="dashboardGuidelineCell" key={guidelineSummary.GLID}>
          <GuidelineCell
            guidelineSummary={guidelineSummary}
            userTrust={trust}
            pgdAck={pgdAck}
            glAck={glAck}
            bookmarked={guidelineBookmarkGLIDs.includes(guidelineSummary.GLID)}
            updated={updated}
            cellClicked={this.pmaCellClicked.bind(this)}
            screenProps={this.props.screenProps}
          />
        </div>
      );
    }

    // render guideline cells for smg card
    let firstUnauthorisedSMG = null;
    for (let smgCardIndex = 0; smgCardIndex < smgCardGuidelineSummaries.length; smgCardIndex++) {
      let guidelineSummary = smgCardGuidelineSummaries[smgCardIndex];

      let updated = this.props.screenProps.isGuidelineUpdated(guidelineSummary);

      let pgdAck = null;
      if (DataController.isAuthorisableGuideline(guidelineSummary)) {
        pgdAck = this.props.screenProps.pgdAcks.find((aPgdAck) => aPgdAck.GLID === guidelineSummary.GLID);
      }

      let glAck = null;
      if (guidelineSummary.SupportAcknowledment === true) {
        glAck = this.props.screenProps.glAcks.find((aGLAck) => aGLAck.GLID === guidelineSummary.GLID);
      }

      let pgdStatus = DataController.getPGDStatus(guidelineSummary, pgdAck, this.props.screenProps.pgdTrustInfo);

      let smgUnauthorised =
        pgdStatus === "UnauthorisedAcknowledge" ||
        pgdStatus === "UnauthorisedQuizTaken" ||
        pgdStatus === "UnauthorisedTakeQuiz";

      if (smgUnauthorised) {
        smgUnauthorisedCount++;
        if (firstUnauthorisedSMG == null) {
          firstUnauthorisedSMG = guidelineSummary;
        }
      }

      // filter out smg's which don't match dropdown
      if (this.state.smgDropdownValue === "Authorised" && pgdStatus !== "Authorised") {
        continue;
      } else if (this.state.smgDropdownValue === "Unauthorised" && !smgUnauthorised) {
        continue;
      }

      smgCardCells.push(
        <div className="dashboardGuidelineCell" key={guidelineSummary.GLID}>
          <GuidelineCell
            guidelineSummary={guidelineSummary}
            userTrust={trust}
            pgdAck={pgdAck}
            glAck={glAck}
            bookmarked={guidelineBookmarkGLIDs.includes(guidelineSummary.GLID)}
            updated={updated}
            cellClicked={this.smgCellClicked.bind(this)}
            screenProps={this.props.screenProps}
          />
        </div>
      );
    }

    // render clinical notice cells for clinical notice card
    let acknowledgedClinicalNoticesCount = 0;
    let unacknowledgedClinicalNoticesCount = 0;
    let firstUnacknowledgedClinicalNotice = null;

    for (
      let clinicalNoticeCardIndex = 0;
      clinicalNoticeCardIndex < clinicalNoticeCardClinicalNotices.length;
      clinicalNoticeCardIndex++
    ) {
      let clinicalNotice = clinicalNoticeCardClinicalNotices[clinicalNoticeCardIndex];

      let isCNAcknowledged = DataController.isCNAcknowledged(clinicalNotice, this.props.screenProps.clinicalNoticeAcks);

      if (isCNAcknowledged) {
        acknowledgedClinicalNoticesCount++;
      } else {
        unacknowledgedClinicalNoticesCount++;
        if (firstUnacknowledgedClinicalNotice == null) {
          firstUnacknowledgedClinicalNotice = clinicalNotice;
        }
      }

      clinicalNoticeCardCells.push(
        <div className="dashboardGuidelineCell" key={clinicalNotice.ID}>
          <ClinicalNoticeCell
            clinicalNotice={clinicalNotice}
            acknowledged={isCNAcknowledged}
            bookmarked={clinicalNoticeBookmarkIDs.includes(clinicalNotice.ID)}
            cellClicked={this.clinicalNoticeClicked.bind(this)}
          />
        </div>
      );
    }

    // render clinical notice cells for local clinical updates card
    for (
      let clinicalNoticeCardIndex = 0;
      clinicalNoticeCardIndex < localClinicalUpdatesCardClinicalNotices.length;
      clinicalNoticeCardIndex++
    ) {
      let clinicalNotice = localClinicalUpdatesCardClinicalNotices[clinicalNoticeCardIndex];

      localClinicalUpdatesCardCells.push(
        <div className="dashboardGuidelineCell" key={"lcu-" + clinicalNotice.ID}>
          <ClinicalNoticeCell
            clinicalNotice={clinicalNotice}
            acknowledged={true}
            bookmarked={clinicalNoticeBookmarkIDs.includes(clinicalNotice.ID)}
            cellClicked={this.clinicalNoticeClicked.bind(this)}
          />
        </div>
      );
    }

    // render significant changes
    let significantChangeAckIDs = this.props.screenProps.significantChangeAcks.map(
      (significantChangeAck) => significantChangeAck.cnid
    );

    let unacknowledgedSignificantChangesCount = 0;

    for (
      let significantChangeIndex = 0;
      significantChangeIndex < this.props.screenProps.significantChanges.length;
      significantChangeIndex++
    ) {
      let significantChange = this.props.screenProps.significantChanges[significantChangeIndex];

      if (significantChangeAckIDs.includes(significantChange.id)) {
        continue;
      } else {
        unacknowledgedSignificantChangesCount++;
      }

      if (significantChangeCells.length >= 5) {
        continue;
      }

      const guidelineSummary = this.props.screenProps.guidelineSummaries.find(
        (guidelineSummary) => guidelineSummary.GLID === significantChange.GLID
      );

      let showAcknowledgeButton = false;
      if (this.props.screenProps.user && this.props.screenProps.user.uid != null) {
        showAcknowledgeButton = true;
      }

      significantChangeCells.push(
        <div key={significantChange.id}>
          <SignificantChangeCell
            significantChange={significantChange}
            guidelineSummary={guidelineSummary}
            acknowledged={false}
            showAcknowledgeButton={showAcknowledgeButton}
            cellClicked={this.significantChangeCellClicked.bind(this)}
            acknowledgeButtonClicked={this.significantChangeCellAcknowledgeButtonClicked.bind(this)}
          />
        </div>
      );
    }

    // render further resources
    for (
      let furtherResourceIndex = 0;
      furtherResourceIndex < this.props.screenProps.furtherResources.length;
      furtherResourceIndex++
    ) {
      let furtherResource = this.props.screenProps.furtherResources[furtherResourceIndex];

      let icon = null;

      for (let i = 0; i < this.props.screenProps.images.length; i++) {
        let image = this.props.screenProps.images[i];
        if (furtherResource.iconFileName === image.name) {
          icon = image.data;
        }
      }

      furtherResourceCells.push(
        <div key={furtherResource.name + "-" + furtherResourceIndex}>
          <FurtherResourceCell
            furtherResource={furtherResource}
            icon={icon}
            cellClicked={this.furtherResourceCellClicked.bind(this)}
          />
        </div>
      );
    }

    // render trust pins
    for (let trustPinsIndex = 0; trustPinsIndex < this.props.screenProps.trustPins.length; trustPinsIndex++) {
      let trustPin = this.props.screenProps.trustPins[trustPinsIndex];

      let icon = null;
      let iconName = "";

      if (trustPin.displayAsDashboardCard) {
        trustPinsDisplayedAsCards.push(trustPin);
      } else {
        // get icon from further resource
        if (
          trustPin.type === "Further Resource" &&
          trustPin.furtherResourceID != null &&
          trustPin.furtherResourceID.length > 0
        ) {
          let furtherResourceForTrustPin = this.props.screenProps.furtherResources.find(
            (furtherResource) => furtherResource.resourceID === trustPin.furtherResourceID[0]
          );
          if (furtherResourceForTrustPin != null && furtherResourceForTrustPin.iconFileName != null) {
            iconName = furtherResourceForTrustPin.iconFileName;
          }
        }

        // get trust pin icon
        if (trustPin.iconFileName !== "") {
          iconName = trustPin.iconFileName;
        }
        if (this.props.screenProps.darkMode && trustPin.iconDarkFileName !== "") {
          iconName = trustPin.iconDarkFileName;
        }

        // get icon path
        if (iconName !== "") {
          let image = this.props.screenProps.images.find((image) => image.name === iconName);
          if (image != null) {
            icon = image.data;
          }
        }

        trustPinCells.push(
          <div key={trustPin.name + "-" + trustPinsIndex}>
            <TrustPinCell trustPin={trustPin} icon={icon} cellClicked={this.trustPinCellClicked.bind(this)} />
          </div>
        );
      }
    }

    // render cells for trust guideline card
    for (
      let trustGuidelineCardIndex = 0;
      trustGuidelineCardIndex < trustGuidelineSummaries.length;
      trustGuidelineCardIndex++
    ) {
      let guidelineSummary = trustGuidelineSummaries[trustGuidelineCardIndex];

      let updated = this.props.screenProps.isGuidelineUpdated(guidelineSummary);

      let pgdAck = null;
      if (DataController.isAuthorisableGuideline(guidelineSummary)) {
        pgdAck = this.props.screenProps.pgdAcks.find((aPgdAck) => aPgdAck.GLID === guidelineSummary.GLID);
      }

      let glAck = null;
      if (guidelineSummary.SupportAcknowledment === true) {
        glAck = this.props.screenProps.glAcks.find((aGLAck) => aGLAck.GLID === guidelineSummary.GLID);
      }

      trustGuidelineCardCells.push(
        <div className="dashboardGuidelineCell" key={guidelineSummary.GLID}>
          <GuidelineCell
            guidelineSummary={guidelineSummary}
            userTrust={trust}
            pgdAck={pgdAck}
            glAck={glAck}
            bookmarked={guidelineBookmarkGLIDs.includes(guidelineSummary.GLID)}
            updated={updated}
            cellClicked={this.pgdCellClicked.bind(this)}
            screenProps={this.props.screenProps}
          />
        </div>
      );
    }

    let otherAppsLayout = [];

    if (this.props.screenProps.user != null) {
      if (
        this.props.screenProps.hideParaPassLinks === false &&
        DataController.hasParaPassSubscription(this.props.screenProps.user.subscriptions)
      ) {
        otherAppsLayout.push(
          <div
            className="menuOtherAppsAppContainer"
            onClick={this.props.screenProps.openParaPass.bind(this)}
            key={"ParaPass"}
          >
            <div className="menuOtherAppsAppFrontContainer">
              <img className="menuOtherAppsAppIcon" src={iconParaPass} alt="" />
              <div className="menuOtherAppsAppTitle">ParaPass</div>
            </div>
            <img
              className="menuOtherAppsOpenIcon"
              src={this.props.screenProps.darkMode ? iconLinkDark : iconLink}
              alt=""
            />
          </div>
        );
      }
      if (
        this.props.screenProps.hideParaPassLinks === false &&
        DataController.hasParaFolioSubscription(this.props.screenProps.user.subscriptions)
      ) {
        otherAppsLayout.push(
          <div
            className="menuOtherAppsAppContainer"
            onClick={this.props.screenProps.openParaFolio.bind(this)}
            key={"ParaFolio"}
          >
            <div className="menuOtherAppsAppFrontContainer">
              <img className="menuOtherAppsAppIcon" src={iconParaFolio} alt="" />
              <div className="menuOtherAppsAppTitle">ParaFolio</div>
            </div>
            <img
              className="menuOtherAppsOpenIcon"
              src={this.props.screenProps.darkMode ? iconLinkDark : iconLink}
              alt=""
            />
          </div>
        );
      }
    }

    // add dashboard cards
    let dashboardCardsLayout = [];

    // looping through dashboard card states as the cards can appear in any custom order
    for (let dashboardCardState of this.state.dashboardCardStates) {
      if (dashboardCardState.removed) {
        continue; // don't show dashboard cards the user has removed
      }

      if (dashboardCardState.name === "Updates & Notices") {
        let updateRows = [];
        if (this.props.features.includes("clinicalNotices") && clinicalNoticeCardClinicalNotices.length > 0) {
          let updateMessage = "You're up to date";
          if (unacknowledgedClinicalNoticesCount > 0 && firstUnacknowledgedClinicalNotice != null) {
            updateMessage = firstUnacknowledgedClinicalNotice.Title;
          }

          updateRows.push({
            title: "Clinical Notices",
            subtitle: updateMessage,
            color: "#FED7D7",
            icon: iconUpdateCN,
            count: unacknowledgedClinicalNoticesCount,
            action: this.seeAllClinicalNoticesClicked.bind(this),
          });
        }
        if (
          this.props.features.includes("localClinicalUpdates") &&
          localClinicalUpdatesCardClinicalNotices.length > 0
        ) {
          updateRows.push({
            title: "Local Clinical Updates",
            subtitle: "Read the latest local clinical updates",
            color: "#FFECBA",
            icon: iconUpdateHouse,
            count: 0,
            action: this.seeAllLocalClinicalUpdatesClicked.bind(this),
          });
        }
        if (this.props.features.includes("pgds") && pgdCardGuidelineSummaries.length > 0) {
          let pgdMessage = "You're up to date";
          if (pgdUnauthorisedCount > 0 && firstUnauthorisedPGD) {
            pgdMessage = firstUnauthorisedPGD.Title;
          }

          updateRows.push({
            title: "Patient Group Directions",
            subtitle: pgdMessage,
            color: "#D7F0FE",
            icon: iconUpdatePeople,
            count: pgdUnauthorisedCount,
            action: this.seeAllPGDsClicked.bind(this),
          });
        }
        if (this.props.features.includes("pmas") && pmaCardGuidelineSummaries.length > 0) {
          let pmaMessage = "You're up to date";
          if (pmaUnauthorisedCount > 0 && firstUnauthorisedPMA != null) {
            pmaMessage = firstUnauthorisedPMA.Title;
          }

          updateRows.push({
            title: "Prescription Medicine Authorisations",
            subtitle: pmaMessage,
            color: "#FFECBA",
            icon: iconUpdatePill,
            count: pmaUnauthorisedCount,
            action: this.seeAllPMAsClicked.bind(this),
          });
        }
        if (this.props.features.includes("smgs") && smgCardGuidelineSummaries.length > 0) {
          let smgCardTitle = "Supplementary Medication Guidelines";
          let smgMessage = "You're up to date";
          if (trust === "EMAS") {
            smgCardTitle = "Medication Supply Guidelines";
          }
          if (smgUnauthorisedCount > 0 && firstUnauthorisedSMG) {
            smgMessage = firstUnauthorisedSMG.Title;
          }

          updateRows.push({
            title: smgCardTitle,
            subtitle: smgMessage,
            color: "#FFECBA",
            icon: iconUpdatePill,
            count: smgUnauthorisedCount,
            action: this.seeAllSMGsClicked.bind(this),
          });
        }
        if (this.props.features.includes("significantChanges")) {
          let firstUnacknowledgedSignificantChange = null;

          for (
            let significantChangeIndex = 0;
            significantChangeIndex < this.props.screenProps.significantChanges.length;
            significantChangeIndex++
          ) {
            let significantChange = this.props.screenProps.significantChanges[significantChangeIndex];

            if (significantChangeAckIDs.includes(significantChange.id)) {
              continue;
            } else {
              if (firstUnacknowledgedSignificantChange == null) {
                firstUnacknowledgedSignificantChange = significantChange;
              }
            }
          }

          let updateMessage = "You’re up to date";
          if (unacknowledgedSignificantChangesCount > 0) {
            if (firstUnacknowledgedSignificantChange != null) {
              updateMessage = firstUnacknowledgedSignificantChange.title;
            }
          }

          updateRows.push({
            title: "Guideline Updates",
            subtitle: updateMessage,
            color: "#DEF6C6",
            icon: iconUpdatePlus,
            count: unacknowledgedSignificantChangesCount,
            action: this.seeAllSignificantChangesClicked.bind(this),
          });
        }
        if (this.props.features.includes("acknowledgeableGuidelines") && acknowledgedGuidelineSummaries.length > 0) {
          let firstUnacknowledgedGuidelineSummary = null;

          for (
            let guidelineSummaryIndex = 0;
            guidelineSummaryIndex < acknowledgedGuidelineSummaries.length;
            guidelineSummaryIndex++
          ) {
            let guidelineSummary = acknowledgedGuidelineSummaries[guidelineSummaryIndex];

            if (guidelineSummaryAckGLIDs.includes(guidelineSummary.GLID)) {
              continue;
            } else {
              if (firstUnacknowledgedGuidelineSummary == null) {
                firstUnacknowledgedGuidelineSummary = guidelineSummary;
              }
            }
          }

          let updateMessage = "You’re up to date";
          if (unacknowledgedGuidelineSummariesCount > 0) {
            if (firstUnacknowledgedGuidelineSummary != null) {
              updateMessage = firstUnacknowledgedGuidelineSummary.Title;
            }
          }

          updateRows.push({
            title: `${DataController.getTrustDisplayName(trust)} Acknowledgeable Guidelines`,
            subtitle: updateMessage,
            color: "#E1C6F6",
            icon: iconUpdateAck,
            count: unacknowledgedGuidelineSummariesCount,
            action: this.seeAllAcknowledgeableGuidelinesClicked.bind(this),
          });
        }

        let totalUpdatesCount =
          updateRows.reduce((n, { count }) => n + count, 0) + this.props.screenProps.notificationCount;
        this.updateTotalUpdatesCount(totalUpdatesCount);

        if (updateRows.length > 0) {
          dashboardCardsLayout.push(
            <AppCard
              key={dashboardCardState.name}
              title="Updates & Notices"
              darkMode={this.props.screenProps.darkMode}
              collapsible={true}
              collapsed={dashboardCardState.collapsed}
              collapsedButtonClicked={this.dashbardCardCollapseButtonClicked.bind(this, dashboardCardState)}
            >
              <div className="dashboardUpdatesRowContainer">
                {updateRows.map((updateRow, index) => {
                  return (
                    <div
                      key={updateRow.title}
                      tabIndex={0}
                      role="button"
                      className="dashboardUpdatesRow"
                      onClick={updateRow.action}
                    >
                      <div className="dashboardUpdatesColorSquare" style={{ backgroundColor: updateRow.color }}>
                        <img className="dashboardUpdatesColorSquareIcon" src={updateRow.icon} />
                      </div>
                      <div className="dashboardUpdatesRowText">
                        <div className="dashboardUpdatesRowTitle">{updateRow.title}</div>
                        <div className="dashboardUpdatesRowSubtitle" aria-hidden="true">
                          {updateRow.subtitle}
                        </div>
                      </div>
                      {updateRow.count > 0 && (
                        <div className="dashboardUpdatesRowBadge" aria-label={`${updateRow.count} unacknowledged`}>
                          {updateRow.count}
                        </div>
                      )}
                      <img alt="" src={disclosureRight} className="dashboardUpdatesDisclosure" />
                    </div>
                  );
                })}
              </div>
            </AppCard>
          );
        }
      }

      if (dashboardCardState.name === "Trust Pins") {
        if (this.props.features.includes("trustPins") && trustPinCells.length > 0) {
          dashboardCardsLayout.push(
            <AppCard
              key={dashboardCardState.name}
              title={`${DataController.getTrustDisplayName(trust)} Pins`}
              removeContentPadding
              darkMode={this.props.screenProps.darkMode}
              collapsible={true}
              collapsed={dashboardCardState.collapsed}
              collapsedButtonClicked={this.dashbardCardCollapseButtonClicked.bind(this, dashboardCardState)}
            >
              <div className="dashboardSubtitleText dashboardTrustPinText">Useful grouped pins</div>
              <div
                className={`dashboardTrustPinCellContainer ${
                  this.state.showAllTrustPins === false ? "dashboardTrustPinCellContainerShowLess" : ""
                }`}
              >
                {trustPinCells}
              </div>
              {this.props.screenProps.trustPins.length > 5 ? (
                <div
                  className="dashboardTrustPinSeeMoreButton"
                  onClick={() => this.setState({ showAllTrustPins: !this.state.showAllTrustPins })}
                >
                  {this.state.showAllTrustPins ? "See less" : "See more"}
                </div>
              ) : null}
            </AppCard>
          );
        }
      }

      for (let trustPin of trustPinsDisplayedAsCards) {
        if (dashboardCardState.name === trustPin.name) {
          let cardTrustPinCells = [];

          // add guidelines to card
          let cardGLIDs = trustPin.guidelines;
          if (trustPin.guidelinesInSections && trustPin.guidelinesInSections.length > 0) {
            cardGLIDs = cardGLIDs.concat(trustPin.guidelinesInSections);
          }

          for (let trustPinGuidelineIndex = 0; trustPinGuidelineIndex < cardGLIDs.length; trustPinGuidelineIndex++) {
            let GLID = cardGLIDs[trustPinGuidelineIndex];
            if (GLID.includes("_")) {
              GLID = GLID.substr(0, GLID.indexOf("_"));
            }
            const guidelineSummary = this.props.screenProps.guidelineSummaries.find(
              (guidelineSummary) => guidelineSummary.GLID === GLID
            );

            if (guidelineSummary != null) {
              let updated = this.props.screenProps.isGuidelineUpdated(guidelineSummary);
              let pgdAck = null;
              if (DataController.isAuthorisableGuideline(guidelineSummary)) {
                pgdAck = this.props.screenProps.pgdAcks.find((aPgdAck) => aPgdAck.GLID === guidelineSummary.GLID);
              }
              let glAck = null;
              if (guidelineSummary.SupportAcknowledment === true) {
                glAck = this.props.screenProps.glAcks.find((aGLAck) => aGLAck.GLID === guidelineSummary.GLID);
              }
              cardTrustPinCells.push(
                <div className="dashboardGuidelineCell" key={guidelineSummary.GLID}>
                  <GuidelineCell
                    guidelineSummary={guidelineSummary}
                    userTrust={trust}
                    pgdAck={pgdAck}
                    glAck={glAck}
                    bookmarked={guidelineBookmarkGLIDs.includes(guidelineSummary.GLID)}
                    updated={updated}
                    cellClicked={() => this.navigateToGuideline(guidelineSummary.GLID, "Dashboard Trust Pin")}
                    screenProps={this.props.screenProps}
                  />
                </div>
              );
            }
          }

          // add clinical notices to card
          let cardCNs = trustPin.clinicalNotices;
          if (trustPin.clinicalNoticesInSections && trustPin.clinicalNoticesInSections.length > 0) {
            cardCNs = cardCNs.concat(trustPin.clinicalNoticesInSections);
          }

          for (let trustPinCNIndex = 0; trustPinCNIndex < cardCNs.length; trustPinCNIndex++) {
            let CNID = cardCNs[trustPinCNIndex];
            if (CNID.includes("_")) {
              CNID = CNID.substr(0, CNID.indexOf("_"));
            }
            const clinicalNotice = this.props.screenProps.clinicalNotices.find(
              (clinicalNotice) => clinicalNotice.ID + "" === CNID
            );

            if (clinicalNotice != null) {
              let isCNAcknowledged = DataController.isCNAcknowledged(
                clinicalNotice,
                this.props.screenProps.clinicalNoticeAcks
              );

              cardTrustPinCells.push(
                <div className="dashboardGuidelineCell" key={clinicalNotice.ID}>
                  <ClinicalNoticeCell
                    clinicalNotice={clinicalNotice}
                    acknowledged={isCNAcknowledged}
                    bookmarked={clinicalNoticeBookmarkIDs.includes(clinicalNotice.ID)}
                    cellClicked={() => this.navigateToClinicalNotice(clinicalNotice, "Dashboard Trust Pin")}
                  />
                </div>
              );
            }
          }

          // add algorithms to card
          let cardALGIDs = trustPin.algorithms;
          if (trustPin.algorithmsInSections && trustPin.algorithmsInSections.length > 0) {
            cardALGIDs = cardALGIDs.concat(trustPin.algorithmsInSections);
          }

          for (let trustPinAlgorithmIndex = 0; trustPinAlgorithmIndex < cardALGIDs.length; trustPinAlgorithmIndex++) {
            let AlgID = cardALGIDs[trustPinAlgorithmIndex];
            if (AlgID.includes("_")) {
              AlgID = AlgID.substr(0, AlgID.indexOf("_"));
            }
            const algorithm = this.props.screenProps.algorithms.find((algorithm) => algorithm.id === AlgID);

            if (algorithm != null) {
              cardTrustPinCells.push(
                <div className="dashboardGuidelineCell" key={algorithm.id}>
                  <GuidelineCell
                    algorithm={algorithm}
                    userTrust={trust}
                    bookmarked={algorithmBookmarkIDs.includes(algorithm.id)}
                    updated={false}
                    cellClicked={() => this.navigateToAlgorithm(algorithm.id, "Dashboard Trust Pin")}
                    screenProps={this.props.screenProps}
                  />
                </div>
              );
            }
          }

          dashboardCardsLayout.push(
            <AppCard
              key={trustPin.name}
              title={trustPin.name}
              darkMode={this.props.screenProps.darkMode}
              collapsible={true}
              collapsed={dashboardCardState.collapsed}
              collapsedButtonClicked={this.dashbardCardCollapseButtonClicked.bind(this, dashboardCardState)}
              seeAllButtonText="See all"
              seeAllButtonClicked={() => this.trustPinCellClicked(trustPin)}
            >
              <div className="horizontalCardCellOuterContainer">
                <div className="horizontalCardCellContainer">{cardTrustPinCells}</div>
              </div>
            </AppCard>
          );
        }
      }

      if (dashboardCardState.name === "Trust Guidelines") {
        if (this.props.features.includes("trustGuidelinesDashboard") && trustGuidelineCardCells.length > 0) {
          dashboardCardsLayout.push(
            <AppCard
              key={dashboardCardState.name}
              title={`${DataController.getTrustDisplayName(trust)} Guidelines`}
              darkMode={this.props.screenProps.darkMode}
              collapsible={true}
              collapsed={dashboardCardState.collapsed}
              collapsedButtonClicked={this.dashbardCardCollapseButtonClicked.bind(this, dashboardCardState)}
              seeAllButtonText="See all"
              seeAllButtonClicked={this.seeAllTrustGuidelinesClicked.bind(this)}
            >
              <div className="horizontalCardCellOuterContainer">
                <div className="horizontalCardCellContainer">{trustGuidelineCardCells}</div>
              </div>
            </AppCard>
          );
        }
      }

      if (dashboardCardState.name === "COVID-19") {
        if (this.props.features.includes("covidDashboard") && covidCardCells.length > 0) {
          dashboardCardsLayout.push(
            <AppCard
              key={dashboardCardState.name}
              title="COVID-19"
              darkMode={this.props.screenProps.darkMode}
              collapsible={true}
              collapsed={dashboardCardState.collapsed}
              collapsedButtonClicked={this.dashbardCardCollapseButtonClicked.bind(this, dashboardCardState)}
              seeAllButtonText="See all"
              seeAllButtonClicked={this.seeAllCovid19Clicked.bind(this)}
            >
              <div className="horizontalCardCellOuterContainer">
                <div className="horizontalCardCellContainer">{covidCardCells}</div>
              </div>
            </AppCard>
          );
        }
      }

      if (dashboardCardState.name === "Time Critical") {
        if (this.props.features.includes("timeCritical") && timeCriticalCardCells.length > 0) {
          dashboardCardsLayout.push(
            <AppCard
              key={dashboardCardState.name}
              title="Time Critical"
              darkMode={this.props.screenProps.darkMode}
              collapsible={true}
              collapsed={dashboardCardState.collapsed}
              collapsedButtonClicked={this.dashbardCardCollapseButtonClicked.bind(this, dashboardCardState)}
              seeAllButtonText="See all"
              seeAllButtonClicked={this.seeAllTimeCriticalClicked.bind(this)}
            >
              <div className="horizontalCardCellOuterContainer">
                <div className="horizontalCardCellContainer">{timeCriticalCardCells}</div>
              </div>
            </AppCard>
          );
        }
      }

      if (dashboardCardState.name === "Shared Procedures") {
        if (this.props.features.includes("sharedProcedures") && sharedProcedureCardCells.length > 0) {
          dashboardCardsLayout.push(
            <AppCard
              key={dashboardCardState.name}
              title="Shared Procedures"
              darkMode={this.props.screenProps.darkMode}
              collapsible={true}
              collapsed={dashboardCardState.collapsed}
              collapsedButtonClicked={this.dashbardCardCollapseButtonClicked.bind(this, dashboardCardState)}
              seeAllButtonText="See all"
              seeAllButtonClicked={this.seeAllSharedProceduresClicked.bind(this)}
            >
              <div className="horizontalCardCellOuterContainer">
                <div className="horizontalCardCellContainer">{sharedProcedureCardCells}</div>
              </div>
            </AppCard>
          );
        }
      }

      if (dashboardCardState.name === "Patient Age") {
        if (this.props.features.includes("patientAgeDashboard")) {
          let pageForAgeMessage = "No patient age filters are currently set";
          if (this.props.screenProps.patientAge.name !== "All") {
            if (this.props.screenProps.patientAge.PFA === "P0010") {
              pageForAgeMessage = `Applicable guidelines and meds will show for patients aged 0 to 1 month`;
            } else {
              pageForAgeMessage = `Applicable guidelines and meds will show for patients aged ${this.props.screenProps.patientAge.name}`;
            }
          }

          dashboardCardsLayout.push(
            <AppCard
              key={dashboardCardState.name}
              title="Set Patient Age"
              darkMode={this.props.screenProps.darkMode}
              headerButtonText="Reset"
              headerButtonClicked={this.resetPatientAge.bind(this)}
            >
              <div className="dashboardSubtitleText">Select a patient age to help filter guidelines and meds</div>
              <AgeSelector
                className="dashboardPageForAgeSelect"
                patientAge={this.props.screenProps.patientAge}
                patientAgeChanged={(patientAge) => this.props.screenProps.updatePatientAge(patientAge, "Dashboard")}
              />
              <div className="dashboardPageForAgeMessage">{pageForAgeMessage}</div>
              {this.props.screenProps.patientAge.PFA !== "none" ? (
                <IonButton
                  className="dashboardPageForAgeButton filledButton"
                  onClick={this.pageForAgeButtonClicked.bind(this)}
                >
                  Go to Page for Age
                </IonButton>
              ) : null}
            </AppCard>
          );
        }
      }

      if (dashboardCardState.name === "My Activity") {
        dashboardCardsLayout.push(
          <AppCard
            key={dashboardCardState.name}
            title="My Activity"
            darkMode={this.props.screenProps.darkMode}
            collapsible={true}
            collapsed={dashboardCardState.collapsed}
            collapsedButtonClicked={this.dashbardCardCollapseButtonClicked.bind(this, dashboardCardState)}
          >
            <div className="activityCardContent">
              <div className="activityCardBookmarks">
                <div className="activityCardContentHeader">
                  <div className="activityCardContentsTitle">Bookmarks</div>
                  <IonButton
                    mode="ios"
                    className="clearButton appCardHeaderButton appCardBorderedButton"
                    fill="clear"
                    onClick={this.seeAllBookmarksClicked.bind(this)}
                  >
                    See All
                  </IonButton>
                </div>
                <div className="activityCardCellContainer">{bookmarkCardCells}</div>
              </div>

              <div className="activityCardDivider" />

              <div className="activityCardRecentlyViewed">
                <div className="activityCardContentHeader">
                  <div className="activityCardContentsTitle">Recently Viewed</div>
                  <IonButton
                    mode="ios"
                    className="clearButton appCardHeaderButton appCardBorderedButton"
                    fill="clear"
                    onClick={this.seeAllRecentlyViewedClicked.bind(this)}
                  >
                    See All
                  </IonButton>
                </div>
                <div className="activityCardCellContainer">{recentlyViewedCardCells}</div>
              </div>
            </div>
          </AppCard>
        );
      }

      if (dashboardCardState.name === "Page for Age") {
        if (this.props.features.includes("pageForAgeDashboard") && pageForAgeCardCells.length > 0) {
          dashboardCardsLayout.push(
            <AppCard
              key={dashboardCardState.name}
              title="Page for Age"
              darkMode={this.props.screenProps.darkMode}
              collapsible={true}
              collapsed={dashboardCardState.collapsed}
              collapsedButtonClicked={this.dashbardCardCollapseButtonClicked.bind(this, dashboardCardState)}
              seeAllButtonText="See all"
              seeAllButtonClicked={this.seeAllPageForAgeClicked.bind(this)}
            >
              <div className="horizontalCardCellOuterContainer">
                <div className="horizontalCardCellContainer">{pageForAgeCardCells}</div>
              </div>
            </AppCard>
          );
        }
      }

      if (dashboardCardState.name === "Further Resources") {
        if (this.props.features.includes("furtherResources") && furtherResourceCells.length > 0) {
          dashboardCardsLayout.push(
            <AppCard
              key={dashboardCardState.name}
              title="Further Resources"
              removeContentPadding
              darkMode={this.props.screenProps.darkMode}
              collapsible={true}
              collapsed={dashboardCardState.collapsed}
              collapsedButtonClicked={this.dashbardCardCollapseButtonClicked.bind(this, dashboardCardState)}
            >
              {furtherResourceCells}
            </AppCard>
          );
        }
      }

      if (dashboardCardState.name === "Your subscriptions") {
        if (this.props.features.includes("dashboardYourSubscriptions") && otherAppsLayout.length > 0) {
          dashboardCardsLayout.push(
            <AppCard
              key={dashboardCardState.name}
              title="Your subscriptions"
              removeContentPadding
              darkMode={this.props.screenProps.darkMode}
              collapsible={true}
              collapsed={dashboardCardState.collapsed}
              collapsedButtonClicked={this.dashbardCardCollapseButtonClicked.bind(this, dashboardCardState)}
            >
              <div className="dashboardCardHeaderSeparator" />
              {otherAppsLayout}
            </AppCard>
          );
        }
      }

      if (dashboardCardState.name === "Feedback") {
        if (this.props.screenProps.helpCentreItems.length > 0) {
          dashboardCardsLayout.push(
            <AppCard key={dashboardCardState.name} title="Feedback" darkMode={this.props.screenProps.darkMode}>
              Need help with any queries? Check out our new Help Centre for all frequently asked questions. If you're
              wanting to supply feedback on the app, please contact us.
              <div className="dashboardFeedbackButtons">
                <IonButton className="clearButton" onClick={this.props.screenProps.showHelpCentre.bind(this)}>
                  Help Centre
                </IonButton>
                <IonButton
                  className="dashboardFeedbackButton clearButton"
                  onClick={this.props.screenProps.sendSupportEmail.bind(this, "Feedback")}
                >
                  Contact us
                </IonButton>
              </div>
            </AppCard>
          );
        } else {
          dashboardCardsLayout.push(
            <AppCard key={dashboardCardState.name} title="Feedback" darkMode={this.props.screenProps.darkMode}>
              If you have any comments or queries about the guidelines or this app, please contact Class Professional
              Publishing below.
              <div className="dashboardFeedbackButtons">
                <IonButton
                  className="dashboardFeedbackButton clearButton"
                  onClick={this.props.screenProps.sendSupportEmail.bind(this, "Feedback")}
                >
                  Contact us
                </IonButton>
              </div>
            </AppCard>
          );
        }
      }

      if (dashboardCardState.name === "Disclaimer" && this.props.screenProps.app === "CFR") {
        dashboardCardsLayout.push(
          <AppCard key={dashboardCardState.name} title="Disclaimer" darkMode={this.props.screenProps.darkMode}>
            The Responder Plus app is for information purposes. Responders must practice according to the local policies
            of your organisation. Do not carry out procedures unless they are within your scope of practice.
          </AppCard>
        );
      }
    }

    let titleText = "";
    let searchText = "Search JRCALC PLUS";
    if (this.props.screenProps.app === "iCPG") {
      titleText = "iCPG";
      searchText = "Search iCPG";
    } else if (this.props.screenProps.app === "Plus") {
      if (this.props.screenProps.trust !== "") {
        titleText = DataController.getTrustDisplayName(this.props.screenProps.trust);
      }
    } else if (this.props.screenProps.app === "CFR") {
      if (this.props.screenProps.trust !== "") {
        titleText = DataController.getTrustDisplayName(this.props.screenProps.trust);
      }
      searchText = "Search Responder Plus";
    }
    if (this.props.screenProps.testMode) {
      titleText = "Test Mode";
    }

    let appNotice = this.props.screenProps.appNotice;

    return (
      <IonPage>
        <IonHeader>
          <IonToolbar mode="ios" className="navBar">
            <IonButtons slot="start">
              <IonMenuButton className="menuButton" autoHide={true} onClick={this.menuButtonClicked.bind(this)}>
                <img width={44} height={44} src={iconMenu} />
              </IonMenuButton>
            </IonButtons>
            <IonTitle>{titleText}</IonTitle>
            <IonButtons slot="end">
              {this.props.features.includes("notificationsPage") ? (
                <IonButton
                  aria-label="Notifications"
                  className="headerButtons headerNotificationContainer"
                  onClick={this.goToNotifications.bind(this)}
                >
                  <IonImg
                    className="headerNotificationIcon"
                    src={this.props.screenProps.notificationCount > 0 ? iconBellActive : iconBellInactive}
                  />
                  {this.props.screenProps.notificationCount > 0 ? (
                    <IonBadge className="headerNotificationCount">{this.props.screenProps.notificationCount}</IonBadge>
                  ) : null}
                </IonButton>
              ) : null}
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent fullscreen>
          <IonRefresher slot="fixed" color="#007aff" onIonRefresh={this.reloadData.bind(this)}>
            <IonRefresherContent></IonRefresherContent>
          </IonRefresher>

          <AppHeader app={this.props.screenProps.app} trust={this.props.screenProps.user?.trust} />

          {this.state.showNotificationBanner ? (
            <div className="notificationBanner">
              <div className="notificationBannerHeader">
                <div className="notificationBannerHeaderLeft">
                  <div className="notificationBannerDot"></div>
                  <div className="notificationBannerTitle">Enable Notifications</div>
                </div>
                <IonButton onClick={this.dismissNotificationBanner.bind(this)}>
                  <img className="icon-10" src={iconClose} />
                </IonButton>
              </div>
              <div className="notificationBannerText">
                Get the latest updates from your trust by enabling notifications.
              </div>
              <IonButton
                mode="ios"
                onClick={this.goToAppSettings.bind(this)}
                className="outlineButton notificationBannerButton"
              >
                Enable notifications
              </IonButton>
            </div>
          ) : null}

          {/* this element is just a fake button to bring up real search */}
          <div className="dashboardSearchStickyContainer">
            <div
              className={`dashboardSearchInputContainer globalContentMargin`}
              onClick={() => this.globalSearchModal.current?.showSearch(true)}
            >
              <img alt="" src={this.props.screenProps.darkMode ? iconSearchDark : iconSearch} className="icon-44" />
              <div className="dashboardSearchPlaceholder">{searchText}</div>
            </div>
          </div>

          {this.state.showWebBanner ? (
            <div className="webAppBanner">
              <div className="webAppBannerTitle">Updated</div>
              <div>
                The iCPG web app has been updated with a new look and additional functionality. This update will be
                launched on Apple and Android devices in due course. Please get in touch at{" "}
                <a
                  className="webAppBannerLink"
                  href="#"
                  onClick={this.props.screenProps.sendSupportEmail.bind(this, "Feedback")}
                >
                  apps@class.co.uk
                </a>{" "}
                about any feedback you have.
              </div>
              <IonButton
                mode="ios"
                className="webAppBannerButton clearButton"
                onClick={this.dismissWebBanner.bind(this)}
              >
                Dismiss
              </IonButton>
            </div>
          ) : null}

          <div className="dashboardContentContainer globalContentMargin">
            {this.state.showCustomiseDashboardCard ? (
              <AppCard
                key={"Customise your Dashboard"}
                title="Customise your Dashboard"
                darkMode={this.props.screenProps.darkMode}
              >
                Change the order of the cards or hide what you no longer want to see. You can also find this option at
                the bottom of the dashboard.
                <div className="dashboardTopCardButtonContainer">
                  <IonButton className="clearButton" onClick={this.dismissCustomiseDashboardCard.bind(this)}>
                    Dismiss
                  </IonButton>
                  <IonButton
                    className="dashboardTopCardActionButton clearButton"
                    onClick={() => {
                      this.editDashboard();
                      this.dismissCustomiseDashboardCard();
                    }}
                  >
                    Edit Dashboard
                  </IonButton>
                </div>
              </AppCard>
            ) : null}

            {appNotice && this.state.showAppNoticesCard ? (
              <AppCard key={"App Notices"} title={appNotice.title} darkMode={this.props.screenProps.darkMode}>
                {appNotice.content}
                <div className="dashboardTopCardButtonContainer">
                  <IonButton className="clearButton" onClick={this.dismissAppNoticesCard.bind(this)}>
                    Dismiss
                  </IonButton>
                  <IonButton
                    className="dashboardTopCardActionButton clearButton"
                    onClick={() => {
                      this.appNoticeCardActionButtonClicked();
                    }}
                  >
                    {appNotice.actionButtonText}
                  </IonButton>
                </div>
              </AppCard>
            ) : null}

            {dashboardCardsLayout}

            <div className="dashboardEditButtonContainer">
              <div className="dashboardEditButton" onClick={this.editDashboard.bind(this)}>
                Edit dashboard
              </div>
            </div>
          </div>

          <GlobalSearchModal
            ref={this.globalSearchModal}
            features={this.props.features}
            screenProps={this.props.screenProps}
            match={this.props.match}
            history={this.props.history}
            furtherResourceCellClicked={this.furtherResourceCellClicked.bind(this)}
          />
        </IonContent>
      </IonPage>
    );
  }
}

export default withRouter(withIonLifeCycle(DashboardPage));
